import type { EventProps } from '../api';
import { openHour, TYPE_GROUPS } from '../format';
import type { DateFilter } from '../state/url-state';

export interface LocalFilters {
  openBy8: boolean;
  hasPhotos: boolean;
}

const DATES: { key: DateFilter; label: string }[] = [
  { key: 'weekend', label: 'This weekend' },
  { key: 'today', label: 'Today' },
  { key: 'tomorrow', label: 'Tomorrow' },
];

export function applyLocalFilters(list: EventProps[], f: LocalFilters): EventProps[] {
  return list.filter((e) => (!f.openBy8 || openHour(e.start_at, e.timezone) <= 8) && (!f.hasPhotos || e.has_photos));
}

export function FilterChips(props: {
  types: string[];
  date: DateFilter;
  local: LocalFilters;
  /** all events in the current search (before type/local filters), for counts */
  all: EventProps[];
  onTypes: (t: string[]) => void;
  onDate: (d: DateFilter) => void;
  onLocal: (f: LocalFilters) => void;
}) {
  const count = (types: string[]) => props.all.filter((e) => types.includes(e.event_type)).length;
  const toggleType = (key: string) =>
    props.onTypes(props.types.includes(key) ? props.types.filter((t) => t !== key) : [...props.types, key]);
  const allOn = props.types.length === 0 && !props.date && !props.local.openBy8 && !props.local.hasPhotos;

  return (
    <div className="chips" role="group" aria-label="Filters">
      <button
        type="button"
        aria-pressed={allOn}
        onClick={() => {
          props.onTypes([]);
          props.onDate('');
          props.onLocal({ openBy8: false, hasPhotos: false });
        }}
      >
        All
      </button>
      {DATES.map((d) => (
        <button key={d.key} type="button" aria-pressed={props.date === d.key} onClick={() => props.onDate(props.date === d.key ? '' : d.key)}>
          {d.label}
        </button>
      ))}
      {TYPE_GROUPS.map((g) => (
        <button key={g.key} type="button" aria-pressed={props.types.includes(g.key)} onClick={() => toggleType(g.key)}>
          {g.label}
          {props.all.length > 0 && <span className="count">{count(g.types)}</span>}
        </button>
      ))}
      <button type="button" aria-pressed={props.local.openBy8} onClick={() => props.onLocal({ ...props.local, openBy8: !props.local.openBy8 })}>
        Open by 8 AM
      </button>
      <button type="button" aria-pressed={props.local.hasPhotos} onClick={() => props.onLocal({ ...props.local, hasPhotos: !props.local.hasPhotos })}>
        Has photos
      </button>
    </div>
  );
}
